import { useState } from "react";

import { makePostApiCall } from "../../../shared/makeApiCall";
import { updateObjectInArray } from "../../../shared/utility";
import DocumentDetailsForm from "../../../components/forms/documents/DocumentDetailsForm";

export function EmployeeDocumentsScreenViewModel(employeeId, logout) {
  const [loading, setLoading] = useState(false);
  const [documents, setDocuments] = useState({
    data: [],
  });
  const [successNotification, setSuccessNotification] = useState({
    show: false,
    title: "",
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const user_id = localStorage.getItem("id") * 1;

  const getEmployeeDocuments = async function (search, page) {
    setLoading(true);
    const authData = {
      action: "fetchEmployeeDocuments",
      userId: 1,
      employee_id: employeeId,
      search: search,
      pageNumber: page,
    };
    let callResult = await makePostApiCall(authData);
    setLoading(false);
    if (callResult.success) {
      setDocuments(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const assignDocumentToEmployee = async function (values) {
    const payload = {
      ...values,
      action: "assignDocumentToEmployee",
      employee_id: employeeId,
    };
    let callResult = await makePostApiCall(
      payload,
      "multipart/form-data",
      "assignedDocuments/assignedDocument/assignDocumentToEmployee.php"
    );

    if (callResult.success) {
      setSlideOver({
        childComponent: null,
        open: false,
      });
      if (callResult.data.status == "overwrite") {
        // TODO OGGY
        console.log("in overwrite");
      } else {
        setSuccessNotification({
          show: true,
          title: "Document added",
        });
        getEmployeeDocuments(null, 0);
      }
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAssignDocumentDocumentSlideOver = () => {
    setSlideOver({
      childComponent: (
        <DocumentDetailsForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={assignDocumentToEmployee}
        />
      ),
      open: true,
    });
  };

  const completeAssignedDocument = async function (values, index) {
    const payload = {
      ...values,
      action: "editDocument",
      user_id: user_id,
    };
    let callResult = await makePostApiCall(
      payload,
      "multipart/form-data",
      "assignedDocuments/assignedDocument/completeAssignedDocument.php"
    );
    if (callResult.success) {
      const currentDocuments = [...documents.data];
      const updateDocument = {
        ...values,
        status: 2,
        status_text: "completed",
      };

      const updatePayload = {
        index: index,
        item: updateDocument,
      };

      const updatedDocuments = updateObjectInArray(
        currentDocuments,
        updatePayload
      );

      const newDocuments = { ...documents, data: updatedDocuments };

      setDocuments(newDocuments);
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setSuccessNotification({
        show: true,
        title: "Document uploaded",
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openEditDocumentSlideOver = (document, index) => {
    setSlideOver({
      childComponent: (
        <DocumentDetailsForm
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          document={document}
          hideName={true}
          actionCall={completeAssignedDocument}
        />
      ),
      open: true,
    });
  };

  return {
    getEmployeeDocuments,
    loading,
    documents,
    openAssignDocumentDocumentSlideOver,
    openEditDocumentSlideOver,
    setSlideOver,
    slideOver,
    setSuccessNotification,
    successNotification,
  };
}
